module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content front in-page detail"
  }, [_c('Breadcrumb', {
    attrs: {
      "lstBreadcrumb": _vm.lstBreadcrumb
    }
  }), _c('div', {
    staticClass: "box-video"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "box-info"
  }, [_c('div', {
    staticClass: "avatar"
  }, [(_vm.video.avatar && _vm.video.avatar.length) ? _c('img', {
    attrs: {
      "src": _vm.video.avatar
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../../assets/images/faces/ic_AvatarDefault.svg")
    }
  })]), _c('div', {
    staticClass: "item-info"
  }, [_c('p', {
    staticClass: "fullname"
  }, [_vm._v(_vm._s(_vm.$t("page.filter.teacher")) + ":"), _c('span', [_vm._v(_vm._s(_vm.video.fullname))])]), _c('div', {
    staticClass: "jobs"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.onLessonSubject(_vm.video.subject_id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("page.filter.subjects")) + ":"), _c('span', {
    staticClass: "subjects"
  }, [_vm._v(_vm._s(_vm.video.subject_name))])]), _c('a', {
    on: {
      "click": function($event) {
        return _vm.onLessonGrade(_vm.video.grade_id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("page.filter.grades")) + ":"), _c('span', {
    staticClass: "grades"
  }, [_vm._v(_vm._s(_vm.video.grade_name))])])]), _c('div', {
    staticClass: "button-public-teacher"
  }, [_c('span', {
    on: {
      "click": _vm.publicTeacher
    }
  }, [_vm._v(_vm._s(_vm.$t("home.qa.view_teacher")))])])]), _c('div', {
    staticClass: "clearfix"
  })])]), _c('div', {
    staticClass: "col-md-9 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "box-detail-content"
  }, [_c('div', {
    staticClass: "box-top-detail"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.video.name))]), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.$t("home.video.date")) + " " + _vm._s(_vm.formatDate(_vm.video.updated_at)))]), _c('div', {
    staticClass: "item-social"
  }, [_c('span', [(!_vm.liked || !_vm.$store.getters.isLoggedIn) ? _c('i', {
    staticClass: "like fa fa-thumbs-o-up",
    attrs: {
      "data-id": _vm.video.id
    },
    on: {
      "click": _vm.likeVideo
    }
  }, [_vm._v(_vm._s(_vm.numberWithCommas(_vm.video.count_like)))]) : _c('i', {
    staticClass: "like fa fa-thumbs-up",
    attrs: {
      "data-id": _vm.video.id
    },
    on: {
      "click": _vm.unLikeVideo
    }
  }, [_vm._v(_vm._s(_vm.numberWithCommas(_vm.video.count_like)))])]), _c('span', [_c('i', {
    staticClass: "fa fa-commenting-o"
  }, [_vm._v(_vm._s(_vm.numberWithCommas(_vm.video.count_comment)))])]), _c('span', [_c('i', {
    staticClass: "fa fa-share-alt"
  }, [_vm._v(_vm._s(_vm.numberWithCommas(_vm.video.count_share)))])]), _c('span', [_c('i', {
    staticClass: "materials material-icons"
  }, [_vm._v("visibility")]), _vm._v(_vm._s(_vm.numberWithCommas(_vm.video.read)))])])]), _c('div', {
    staticClass: "box-middle-detail"
  }, [(_vm.video.link_video && _vm.video.link_video.length > 0) ? _c('div', {
    staticClass: "box-item-video"
  }, [(!_vm.isShowing) ? _c('div', {
    class: {
      'collapse': _vm.isShowing
    }
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.playVideo
    }
  }, [_vm._m(0)]), (_vm.video.banner && _vm.video.banner.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.video.banner[0]
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../../assets/Obee_Logo_140@2x.png")
    }
  })]) : _vm._e(), _c('video', {
    ref: "videoRef",
    staticClass: "box-video-play",
    class: {
      'collapse': !_vm.isShowing
    },
    attrs: {
      "id": "video-container",
      "width": "679px",
      "height": "382px",
      "controls": "controls"
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "content-detail",
    domProps: {
      "innerHTML": _vm._s(_vm.rawHtml(_vm.video.content))
    }
  })]), (_vm.video.files && _vm.video.files !== null) ? _c('div', {
    staticClass: "box-bottom-detail"
  }, [_c('div', {
    staticClass: "related"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("home.video.attach")) + ":")])]), _c('div', {
    staticClass: "related-item"
  }, _vm._l((_vm.video.files), function(file, index) {
    return _c('div', {
      staticClass: "file-item",
      on: {
        "click": function($event) {
          return _vm.download(file)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file"
    }), _c('span', [_vm._v(_vm._s(_vm.getFileName(file)))])])
  }), 0)]) : _vm._e()])])]), _c('div', {
    staticClass: "clearfix"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', {
    staticClass: "material-icons"
  }, [_vm._v("play_arrow")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-215487ab","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/Page/Public/detail.vue
// module id = 1503
// module chunks = 0